export default "__VITE_ASSET__TYfC2opx__"